import React, { createContext, ReactElement, ReactNode, useContext } from 'react'

import { SubscriptionPeriod } from '@modules-deprecated/app/organization/enums/subscriptionPeriod'
import { SubscriptionPlan } from '@modules-deprecated/app/organization/enums/subscriptionPlan'

interface ContextState {
  isMonthlyPeriodForced: boolean
  selectPlan: (plan: SubscriptionPlan, period?: SubscriptionPeriod) => void
}

const PlanSelectionContext = createContext<ContextState | undefined>(undefined)

interface PlanSelectionContextProps {
  children?: ReactNode
  isMonthlyPeriodForced?: boolean
  onPlanSelect: (plan: SubscriptionPlan, period?: SubscriptionPeriod) => void
}

export const PlanSelectionContextProvider = ({
  children,
  isMonthlyPeriodForced = false,
  onPlanSelect,
}: PlanSelectionContextProps): ReactElement => (
  <PlanSelectionContext.Provider
    value={{
      isMonthlyPeriodForced,
      selectPlan: onPlanSelect,
    }}
  >
    {children}
  </PlanSelectionContext.Provider>
)

export const useSelectPlan = () => {
  const context = useContext(PlanSelectionContext)

  if (!context) {
    throw new Error('PlanSelectionContextProvider is missing in the module!')
  }

  return context
}
